import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { merge, of, Subject, Subscription } from "rxjs";
import {
    catchError,
    filter,
    map,
    switchMap,
    takeUntil,
    tap,
} from "rxjs/operators";
import { Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { CotizacionDTO } from "app/main/apps/shared/interfaces/cotizacion.interface";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { PageCotizacionDTO } from "app/main/apps/shared/interfaces/page-cotizacion.interface";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { CotizacionesService } from "app/main/apps/shared/services/rest/cotizaciones.service";

@Component({
    selector: "app-tabla-cotizaciones",
    templateUrl: "./tabla-cotizaciones.component.html",
    styleUrls: ["./tabla-cotizaciones.component.scss"],
    animations: fuseAnimations,
})
export class TablaCotizacionesComponent implements OnInit, OnDestroy {
    @Input() cotizaciones: CotizacionDTO[];
    @Input() total: number;
    @Input() procesando:boolean;
    @Output()
    solicitarActualizacionEvent: EventEmitter<number> = new EventEmitter();
    @Output()
    actualizarVigenciaEvent: EventEmitter<number> = new EventEmitter();

    @Output() buscarMas: EventEmitter<any> = new EventEmitter();
    dataSource: MatTableDataSource<CotizacionDTO>;
    displayedColumns = [
        "idsolicitudcotizacion",
        "vigente",
        "estado",
        "fechaSolicitud",
        "cliente",
        "valor",
        "fechaVigencia",
        "acciones",
    ];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    //    @ViewChild("filter", { static: true })
    //  filter: ElementRef;

    resultsLength = 0;
    private subscripciones: Subscription;
    private _unsubscribeAll: Subject<any>;


    constructor(
        private _router: Router,
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _cotizacionSrvc: CotizacionesService
    ) {
        this._unsubscribeAll = new Subject();
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource(this.cotizaciones);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        /*this._cotizacionSrvc.onCotizacionChanged$.subscribe(resp=>{
            this.dataSource = new MatTableDataSource(resp.content);
            //this.dataSource = new MatTableDataSource(this.cotizaciones);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;    
        })*/

        this.subscripciones.add(
            this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0))
        );

        //this.buscadorListen();

        setTimeout(() => {
            this.tableChange();
        });
    }

    // buscadorListen() {
    //     fromEvent(this.filter.nativeElement, "keyup")
    //         .pipe(
    //             takeUntil(this._unsubscribeAll),
    //             debounceTime(150),
    //             distinctUntilChanged()
    //         )
    //         .subscribe(() => {
    //             if (!this.dataSource) {
    //                 return;
    //             }
    //             console.log("entro");
    //             console.log(this.filter.nativeElement.value);
    //             this.dataSource.filter = this.filter.nativeElement.value;
    //         });
    // }

    tableChange() {
        //console.log(this.total);
        this.resultsLength = this.total;
        this.subscripciones.add(
            merge(
                this.sort.sortChange,
                this.paginator.page,
                this._cotizacionSrvc.cotizacionesRefresh$.pipe(
                    tap((data) => console.log("refresh!", data)),
                    filter(
                        (refresh) => refresh //filtro para cotizacionesRefresh$, merge se activa solo si el valor emitido es true, para evitar dobles llamadas
                    )
                )
            )
                .pipe(
                    // startWith({}),
                    takeUntil(this._unsubscribeAll),
                    switchMap(() => {
                        this._fuseProgressBarService.show();
                        this._cotizacionSrvc.setPaginaActual(
                            this.paginator.pageIndex
                        );
                        this._cotizacionSrvc.setCantidaResultadosPorPagina(
                            this.paginator.pageSize
                        );

                        this._cotizacionSrvc.setCampoOrden(this.sort.active);
                        this._cotizacionSrvc.setOrden(this.sort.direction);

                        this.buscarMas.emit();
                        //return this.buscar();
                        return this._cotizacionSrvc.onCotizacionChanged$;
                    }),
                    map((data: PageCotizacionDTO) => {
                        // Flip flag to show that loading has finished.

                        this._fuseProgressBarService.hide();
                        this.resultsLength = data.totalElements;

                        return data.content;
                    }),
                    catchError(() => {
                        this._fuseProgressBarService.hide();
                        // Catch if the GitHub API has reached its rate limit. Return empty data.

                        return of([]);
                    })
                )
                .subscribe((data: CotizacionDTO[]) => {
                    this.cotizaciones = data;
                    this.dataSource = new MatTableDataSource(this.cotizaciones);
                })
        );
    }

    detalle(id): void {
        this._router.navigateByUrl("cotizaciones/" + id);
    }

    solicitarActualizacion(idCotizacion: number) {
        this.solicitarActualizacionEvent.emit(idCotizacion);
    }

    actualizarVigencia(idCotizacion: number) {
        this.actualizarVigenciaEvent.emit(idCotizacion);
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subscripciones.unsubscribe();
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
